<template>
  <div class="home">
    <!-- <Navbar /> -->
    <DashBoard TIME="BÁO CÁO SAIGON CHILL"/>
    <vue-headful title="BÁO CÁO SAIGON CHILL" />
  </div>
</template>

<script>
// @ is an alias to /src
import DashBoard from "@/components/DashBoard.vue";
// import Navbar from "@/components/Navbar.vue";

export default {
  name: "Report",
  components: {
    DashBoard,
    // Navbar,
  },
};
</script>
<style>
body {
  background-color: white !important;
}

.footer {
  color: black !important;
}
</style>